import { AppUpdateNotice } from '@pos/design-system';
import { useAppUpdate } from '@pos/offline';

/** A new version is ready: it starts when the user reloads (ARCHITECTURE.md, "Web apps"). */
export function UpdateNotice() {
  const waiting = useAppUpdate((s) => s.waiting);
  const reload = useAppUpdate((s) => s.reload);
  return <AppUpdateNotice open={waiting} onReload={reload} placement="top" />;
}
